import React from "react";

export const SocialMediaSection = () => {
  return (
    <section className="social-media-section">
      <style jsx>{`
        .social-media-section {
          background: #f8fafc;
          padding: 80px 0;
        }

        .container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 20px;
        }

        .section-header {
          text-align: center;
          margin-bottom: 60px;
        }

        .section-title {
          font-size: 2.5rem;
          font-weight: bold;
          color: #1f2937;
          margin-bottom: 16px;
          position: relative;
        }

        .section-title::after {
          content: "";
          position: absolute;
          bottom: -8px;
          left: 50%;
          transform: translateX(-50%);
          width: 80px;
          height: 4px;
          background: linear-gradient(90deg, #3b82f6, #8b5cf6);
          border-radius: 2px;
        }

        .section-subtitle {
          font-size: 1.1rem;
          color: #6b7280;
          max-width: 600px;
          margin: 0 auto;
        }

        .social-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 40px;
          align-items: start;
        }

        .social-column {
          background: white;
          border-radius: 16px;
          padding: 30px;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
          transition: all 0.3s ease;
          position: relative;
          overflow: hidden;
        }

        .social-column::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 4px;
          background: linear-gradient(
            90deg,
            var(--brand-color, #3b82f6),
            var(--brand-color-secondary, #8b5cf6)
          );
        }

        .social-column:hover {
          transform: translateY(-4px);
          box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),
            0 10px 10px -5px rgba(0, 0, 0, 0.04);
        }

        .social-column.facebook {
          --brand-color: #1877f2;
          --brand-color-secondary: #42a5f5;
        }

        .social-column.twitter {
          --brand-color: #1da1f2;
          --brand-color-secondary: #64b5f6;
        }

        .social-column.instagram {
          --brand-color: #e4405f;
          --brand-color-secondary: #fd79a8;
        }

        .social-column.youtube {
          --brand-color: #ff0000;
          --brand-color-secondary: #ff5722;
        }

        .social-header {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 20px;
        }

        .social-icon {
          width: 40px;
          height: 40px;
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1.5rem;
          color: white;
          background: linear-gradient(
            135deg,
            var(--brand-color),
            var(--brand-color-secondary)
          );
        }

        .social-title {
          font-size: 1.3rem;
          font-weight: bold;
          color: #1f2937;
        }

        .social-description {
          color: #6b7280;
          margin-bottom: 20px;
          line-height: 1.6;
        }

        .embed-placeholder {
          background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
          border: 2px dashed #cbd5e1;
          border-radius: 12px;
          padding: 40px 20px;
          text-align: center;
          color: #64748b;
          min-height: 300px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 12px;
          transition: all 0.3s ease;
        }

        .embed-placeholder:hover {
          border-color: var(--brand-color);
          background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
        }

        .placeholder-icon {
          font-size: 3rem;
          opacity: 0.7;
        }

        .placeholder-title {
          font-size: 1.1rem;
          font-weight: 600;
          margin-bottom: 8px;
        }

        .placeholder-text {
          font-size: 0.9rem;
          opacity: 0.8;
          max-width: 280px;
        }

        .follow-button {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          background: linear-gradient(
            135deg,
            var(--brand-color),
            var(--brand-color-secondary)
          );
          color: white;
          padding: 10px 20px;
          border-radius: 8px;
          text-decoration: none;
          font-weight: 600;
          font-size: 0.9rem;
          transition: all 0.3s ease;
          border: none;
          cursor: pointer;
          margin-top: 12px;
        }

        .follow-button:hover {
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
          color: white;
        }

        /* Responsive Design */
        @media (max-width: 768px) {
          .social-media-section {
            padding: 60px 0;
          }

          .section-title {
            font-size: 2rem;
          }

          .social-grid {
            grid-template-columns: 1fr;
            gap: 30px;
          }

          .social-column {
            padding: 24px;
          }

          .embed-placeholder {
            min-height: 250px;
            padding: 30px 15px;
          }

          .placeholder-icon {
            font-size: 2.5rem;
          }
        }

        @media (max-width: 480px) {
          .section-title {
            font-size: 1.8rem;
          }

          .social-column {
            padding: 20px;
          }

          .embed-placeholder {
            min-height: 200px;
            padding: 25px 15px;
          }
        }
      `}</style>

      <div className="container">
        {/* Header de la sección */}
        <div className="section-header">
          <h2 className="section-title">📱 Síguenos en Redes Sociales</h2>
          <p className="section-subtitle">
            Mantente conectado con nosotros y no te pierdas las últimas noticias
            y actualizaciones
          </p>
        </div>

        {/* Grid de redes sociales */}
        <div className="social-grid">
          {/* Columna 1 - Facebook */}
          <div className="social-column facebook">
            <div className="social-header">
              <div className="social-icon">📘</div>
              <div>
                <h3 className="social-title">Facebook</h3>
              </div>
            </div>

            <p className="social-description">
              Únete a nuestra comunidad en Facebook y mantente al día con las
              noticias más importantes de la región. Comparte, comenta y
              participa en nuestras publicaciones.
            </p>

            <div className="embed-placeholder">
              <div className="placeholder-icon">📘</div>
              <div className="placeholder-title">Widget de Facebook</div>
              <div className="placeholder-text">
                Aquí se mostrará el feed de publicaciones de Facebook o el botón
                de "Me gusta" de la página
              </div>
              <a href="#" className="follow-button">
                <span>👍</span>
                <span>Seguir en Facebook</span>
              </a>
            </div>
          </div>

          {/* Columna 2 - Twitter/X */}
          <div className="social-column twitter">
            <div className="social-header">
              <div className="social-icon">🐦</div>
              <div>
                <h3 className="social-title">Twitter / X</h3>
              </div>
            </div>

            <p className="social-description">
              Síguenos en Twitter para recibir actualizaciones en tiempo real,
              noticias de último momento y participar en conversaciones sobre
              los temas más relevantes.
            </p>

            <div className="embed-placeholder">
              <div className="placeholder-icon">🐦</div>
              <div className="placeholder-title">Timeline de Twitter</div>
              <div className="placeholder-text">
                Aquí se mostrará el timeline de tweets más recientes o el botón
                de seguir
              </div>
              <a href="#" className="follow-button">
                <span>🐦</span>
                <span>Seguir en Twitter</span>
              </a>
            </div>
          </div>
        </div>

        {/* Sección adicional opcional */}
        <div style={{ marginTop: "60px", textAlign: "center" }}>
          <div
            style={{
              background: "white",
              padding: "30px",
              borderRadius: "16px",
              boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1)",
              display: "inline-block",
            }}
          >
            <h3
              style={{
                fontSize: "1.3rem",
                fontWeight: "bold",
                color: "#1f2937",
                marginBottom: "12px",
              }}
            >
              🔔 ¿Quieres más actualizaciones?
            </h3>
            <p
              style={{
                color: "#6b7280",
                marginBottom: "20px",
                maxWidth: "400px",
              }}
            >
              Suscríbete a nuestro newsletter y recibe las noticias más
              importantes directamente en tu correo
            </p>
            <button
              style={{
                background: "linear-gradient(135deg, #3b82f6, #8b5cf6)",
                color: "white",
                padding: "12px 24px",
                borderRadius: "8px",
                border: "none",
                fontWeight: "600",
                cursor: "pointer",
                transition: "transform 0.3s ease",
              }}
              onMouseEnter={(e) =>
                (e.target.style.transform = "translateY(-2px)")
              }
              onMouseLeave={(e) => (e.target.style.transform = "translateY(0)")}
            >
              📧 Suscribirse al Newsletter
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};
